import ImageUpload from "../FaceSwap/ImageUploader";
import {useAIToolsContext} from "../../../../../../../../../../context/AIToolsProvider";
import {useADSContext} from "../../../../../../../../../../context/ADSProvider";
import useFetchAuthImage from "../../../../../../../../../../../../../../Hooks/useFetchAuthImage";

const FaceCorrection = () => {
  const {
    firstSelectedImage,
    setFirstSelectedImage,

    firstBoundingBox,
    setFirstBoundingBox,
    firstBoundingBoxSelectedIndexes,

    setFirstBoundingBoxSelectedIndexes,

    firstSelectedImageServerPath,
    setFirstSelectedImageServerPath,
  } = useAIToolsContext();

  const {handleSelectProduct} = useADSContext();

  const {data: authImageSrc, loading: loadingAuthImageSrc} = useFetchAuthImage({path: firstSelectedImageServerPath})

  const clearImage = () => {
    setFirstSelectedImage(null);
    setFirstBoundingBox([]);
    setFirstBoundingBoxSelectedIndexes(null);
    setFirstSelectedImageServerPath(null);
    handleSelectProduct({})
  }

  return (
    <ImageUpload
      inputId='first-image-upload' // id to trigger input tag, must be unique
      label="Upload from device"
      loading={loadingAuthImageSrc}
      uploadedUrl={authImageSrc}
      uploadedFile={firstSelectedImage}
      onUploadFile={setFirstSelectedImage}
      onDeleteFile={clearImage}
      boundingBox={firstBoundingBox}
      boundingBoxSelectedIndexes={firstBoundingBoxSelectedIndexes}
      setBoundingBoxSelectedIndexes={setFirstBoundingBoxSelectedIndexes}
      swapFaceImagePath={firstSelectedImageServerPath}
      num={1}
      width={560}
      height={560}
    />
  );
};

export default FaceCorrection;
